import { lazy } from "react";

const Home = lazy(() => import("../../pages/Home"));
const Login = lazy(() => import("../../pages/Auth/Login"));
const Signup = lazy(() => import("../../pages/Auth/Signup"));
const About = lazy(() => import("../../pages/About"));
const Payments = lazy(() => import("../../pages/Course/Payments"));
const Checkout = lazy(() => import("../../pages/Checkout"));
const Course = lazy(() => import("../../pages/Course"));
const ActiveCourse = lazy(() => import("../../pages/Course/ActiveCourse"));
const ViewCourse = lazy(() => import("../../pages/Course/ViewCourse"));
const VerifyEmail = lazy(() => import("../../pages/Auth/VerifyEmail"));
const ForgotPassword = lazy(() => import("../../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../../pages/Auth/ResetPassword"));


export interface Route {
  name: string;
  path: string;
  component: any;
  protected: boolean;
}

export const publicRoute: Route[] = [
  {
    name: "Home",
    path: "/",
    component: Home,
    protected: false,
  },
  {
    name: "Checkout",
    path: "/checkout",
    component: Checkout,
    protected: false,
  },
  {
    name: "Courses",
    path: "/courses",
    component: Course,
    protected: false,
  },
  {
    name: "ViewCourse",
    path: "/courses/:id",
    component: ViewCourse,
    protected: false,
  },

  {
    name: "ActiveCourse",
    path: "/courses/:id/:courseName",
    component: ActiveCourse,
    protected: false,
  },
  {
    name: "About",
    path: "/about",
    component: About,
    protected: false,
  },
  {
    name: "Payment",
    path: "/payment/verify",
    component: Payments,
    protected: false,
  },
 
  {
    name: "Login",
    path: "/login",
    component: Login,
    protected: false,
  },
  {
    name: "VerifyEmail",
    path: "/verify",
    component: VerifyEmail,
    protected: false,
  },
  {
    name: "Signup",
    path: "/signup",
    component: Signup,
    protected: false,
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    protected: false,
  },
  {
    name: "ResetPassword",
    path: "/reset-password",
    component: ResetPassword,
    protected: false,
  },
];
